import {getLayoutDefaultValue,getStyleDefaultValue,getTextDefaultValue} from "../../../utils/configuration/defaultSchema/schema.util";
import {COMPONENT_SCHEMA,EVENTS_SCHEMA} from '../../../utils/configuration/schema'

export const sliderDefaultSchema = (data) => {
    const {componentName,componentId,isPage} = data; return {
        component: {
            [COMPONENT_SCHEMA.ID]: `${componentName}${componentId !== '' ? '_' : ''}${componentId}`,
            [COMPONENT_SCHEMA.COMPONENT_NAME]: `${componentName}`,
            [COMPONENT_SCHEMA.SOURCE]: '',
            [COMPONENT_SCHEMA.LABEL_TYPE]: 'caption',
            [COMPONENT_SCHEMA.ENABLED]: true,
            [COMPONENT_SCHEMA.MIN]: 0,
            [COMPONENT_SCHEMA.MAX]: 10,
            [COMPONENT_SCHEMA.STEP]: 1,
        },
        text: getTextDefaultValue(data),
        style: getStyleDefaultValue(data),
        layout: getLayoutDefaultValue(data),
        events: [
            EVENTS_SCHEMA.CHANGE
        ]
    }
}